var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165.373,
    height: 229.524,
    viewBox: "0 0 165.373 229.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-126.689 -56.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(29 -219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M200.576,496.257l9.346,4.309-9.346,4.82,2.772-4.82Z",
    transform: "translate(52 -220)",
    fill: "#bfbfbf",
    stroke: "#bfbfbf",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x1: 122,
    transform: "translate(133.5 280.5)",
    fill: "none",
    stroke: "#bfbfbf",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-6.811 -110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M200.576,496.257l9.346,4.309-9.346,4.82,2.772-4.82Z",
    transform: "translate(87.811 -220)",
    fill: "#bfbfbf",
    stroke: "#bfbfbf",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-2",
    "data-name": "Line 6",
    x1: 157.811,
    transform: "translate(133.5 280.5)",
    fill: "none",
    stroke: "#bfbfbf",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(29 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2-3",
    "data-name": "Path 2",
    d: "M200.576,496.257l9.346,4.309-9.346,4.82,2.772-4.82Z",
    transform: "translate(52 -220)",
    fill: "#bfbfbf",
    stroke: "#bfbfbf",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-3",
    "data-name": "Line 6",
    x1: 122,
    transform: "translate(133.5 280.5)",
    fill: "none",
    stroke: "#bfbfbf",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y2: 218.75,
    transform: "translate(162.5 61.1)",
    fill: "none",
    stroke: "#bfbfbf",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/Arrows.1cda68db018ede7ae53888efe876f51b.svg";
export { ForwardRef as ReactComponent };